import Vue from 'vue'

const mutations = {
	setClientsManualToolsStatisticsData (state, data) {
		Vue.set(state, 'clientsManualToolsStatisticsData', data)
	}
}

export default mutations
